import { BiometricStatus } from '@models/biometric';
import * as NativeUtils from '@utils/nativeUtils';

import useNativeListener from './useNativeListener';

interface CallbackProps {
    status: BiometricStatus;
    pin?: string;
}

interface Props {
    onSuccess: (pin: string) => void;
    onError?: (status: Exclude<BiometricStatus, 'success' | 'not_registered'>) => void;
    onNotRegister?:() =>void;
}

function useAuthenticatePin({ onSuccess, onError, onNotRegister }:Props) {
    useNativeListener('authenticateBiometricPin', ({ status, pin }: CallbackProps) => {
        if (status === 'success') {
            onSuccess?.(pin!);
        } else if (status === 'not_registered') {
            onNotRegister?.();
        } else {
            onError?.(status);
        }
    }, [onSuccess, onError, onNotRegister]);

    const authenticatePin = () => {
        NativeUtils.authenticatePin();
    };

    return {
        authenticatePin,
    };
}

export default useAuthenticatePin;
